import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../../firebaseConfig";

import AnnouncementsDashboard from "./dashboard/AnnouncementsDashboard";
import CreateAnnouncementPage from "./create/CreateAnnouncementPage";
import EditAnnouncementPage from "./edit/EditAnnouncementPage";
import AnnouncementPostView from "./dashboard/AnnouncementPostView";

import "./AdminAnnouncementsShell.css";

async function loadProfile(user) {
  if (!user) return null;
  try {
    const snap = await getDoc(doc(db, "users", user.uid));
    const data = snap.exists() ? (snap.data() || {}) : {};
    return {
      uid: user.uid,
      email: user.email || data.email || "",
      name: data.name || user.displayName || "User",
      role: data.role || "unknown",
    };
  } catch (e) {
    return {
      uid: user.uid,
      email: user.email || "",
      name: user.displayName || "User",
      role: "unknown",
    };
  }
}

export default function AdminAnnouncements() {
  const [me, setMe] = useState(null);
  const [page, setPage] = useState({ name: "dashboard" });

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) { setMe(null); return; }
      const prof = await loadProfile(user);
      setMe(prof);
    });
    return () => unsub();
  }, []);

  const goDashboard = () => setPage({ name: "dashboard" });
  const goCreate = () => setPage({ name: "create" });
  const goEdit = (id) => {
    if (!id) return;
    setPage({ name: "edit", id });
  };
  const goPost = (id) => {
    if (!id) return;
    setPage({ name: "post", id });
  };

  return (
    <div className="aaShell">
      <div className="aaShellInner">
        {page.name === "dashboard" && (
          <AnnouncementsDashboard
            me={me}
            onCreate={goCreate}
            onEdit={goEdit}
            onOpenPost={goPost}
          />
        )}

        {page.name === "create" && (
          <CreateAnnouncementPage
            me={me}
            prefill={{}}
            onCancel={goDashboard}
            onCreated={goDashboard}
          />
        )}

        {page.name === "edit" && (
          <EditAnnouncementPage
            me={me}
            announcementId={page.id}
            onCancel={goDashboard}
            onSaved={goDashboard}
          />
        )}

        {page.name === "post" && (
          <AnnouncementPostView
            me={me}
            announcementId={page.id}
            onBack={goDashboard}
            onEdit={goEdit}
          />
        )}
      </div>
    </div>
  );
}
